export default {
  withdraw: {
    title: 'Retirar',
    subtitle: 'Rápido, seguro y conveniente',
    secureEncrypted: 'Seguro y Encriptado',
    fiatOrCash: 'Fiat/Efectivo',
    processing: 'Procesando...',
    select: 'Seleccionar',
    withdrawCurrency: 'Moneda de Retiro',
    chooseNetwork: 'Elegir Red',
    channel: 'Canal',
    withdrawalAddress: 'Dirección de Retiro',
    pixKeyType: 'Tipo de Clave PIX',
    accountNumber: 'Número de Cuenta',
    enterAccountNumber: 'Ingrese el número de su cuenta',
    accountName: 'Nombre de la Cuenta',
    enterAccountName: 'Ingrese el nombre del titular de la cuenta',
    pixKey: 'Clave PIX',
    enterPixKey: 'Ingrese su clave PIX',
    cpf: 'CPF',
    enterCpf: 'Ingrese el CPF',
    bankName: 'Nombre del Banco',
    enterBankName: 'Ingrese el nombre del banco',
    branch: 'Sucursal',
    enterBranch: 'Ingrese la sucursal (opcional)',
    phone: 'Teléfono',
    enterPhone: 'Ingrese el teléfono (opcional)',
    email: 'Correo electrónico',
    enterEmail: 'Ingrese el correo electrónico (opcional)',
    available: 'Retirable',
    amountPlaceholder: 'Monto ({unit})',
    min: 'Mín',
    max: 'Máx',
    totalWithdrawalAmount: 'Monto total del retiro:',
    fee: 'Comisión:',
    withdrawalAmount: 'Monto del Retiro:',
    fundsSafeTitle: 'Tus fondos están seguros con nosotros',
    fundsSafeDesc: 'Usamos seguridad de vanguardia para proteger tus transacciones e información personal.',
    enterWithdrawalAddress: 'Por favor ingrese la dirección de retiro',
    enterAccountNumberRequired: 'Por favor ingrese el número de su cuenta',
    selectChannelRequired: 'Por favor selecciona un canal',
    enterAccountNameRequired: 'Por favor ingrese el nombre del titular de la cuenta',
    selectPixKeyTypeRequired: 'Por favor selecciona el tipo de clave PIX',
    enterCpfRequired: 'Por favor ingrese el CPF',
    enterValidAmount: 'Por favor ingrese un monto válido',
    minWithdrawal: 'Retiro mínimo: {amount} {unit}',
    maxWithdrawal: 'Retiro máximo: {amount} {unit}',
    insufficientBalance: 'Saldo disponible insuficiente',
    withdrawalRejected: 'Retiro rechazado',
    submittedPendingReview: 'Retiro enviado, pendiente de revisión',
    submittedPayoutInProgress: 'Retiro enviado, pago en proceso',
    withdrawalFailed: 'Retiro fallido',
    withdrawalFailedRetry: 'Retiro fallido, por favor intenta de nuevo',
  },
};
